import React, { useState, useEffect } from 'react';
import { CssBaseline, Grid } from '@material-ui/core';

import { getPlacesData, getWeatherData } from './api/index';
import List from './components/List/List';
import Header from './components/Header/Header';
import Map from './components/Map/Map';
import { RestaurantRounded } from '@material-ui/icons';

const DEFAULT_BOUNDS = {
  sw: { lat: 45.466014721319766, lng: -73.70280711462951 },
  ne: { lat: 45.519804102949365, lng: -73.50625483801818 }
};

function App() {
  const [places, setPlaces] = useState([]);
  const [fileteredPlaces, setFileteredPlaces] = useState([]);
  const [childClicked, setChildClicked] = useState(null);

  const [coordinates, setCoordinates] = useState({});
  const [bounds, setBounds] = useState(DEFAULT_BOUNDS);
  const [isLoading, setIsLoading] = useState(false);
  const [type, setType] = useState('restaurants');
  const [rating, setRating] = useState('');
  // const [weatherData, setWeatherData] = useState(null);
  //get user location
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(({ coords: { latitude, longitude } }) => {
      setCoordinates({ lat: latitude, lng: longitude });
    })

    // setBounds(DEFAULT_BOUNDS);
  }, []);

  useEffect(() => {
    const filterPlaces = places.filter((place) => {
      return place.rating > rating;
    })
    setFileteredPlaces(filterPlaces);
  }, [rating]);

  useEffect(() => {
    if (!bounds.sw || !bounds.ne) return;
    setIsLoading(true);

    // getWeatherData(coordinates.lat, coordinates.lng).then((data) => setWeatherData(data));

    getPlacesData(type, bounds.sw, bounds.ne)
      .then((data) => {
        // console.log(data);
        setFileteredPlaces([]);
        setPlaces(data?.filter(place => place.name && place.num_reviews > 0));
        setIsLoading(false);
      })
  }, [type, bounds]);
  return (
    <>
      <CssBaseline />
      <Header setCoordinates={setCoordinates} />
      <Grid container spacing={3} style={{ width: '100%' }}>
        <Grid item xs={12} md={4}>
          <List places={fileteredPlaces.length ? fileteredPlaces : places} childClicked={childClicked} isLoading={isLoading} type={type} setType={setType} rating={rating} setRating={setRating} />
        </Grid>
        <Grid item xs={12} md={8}>
          <Map
            setCoordinates={setCoordinates}
            setBounds={setBounds}
            coordinates={coordinates}
            places={fileteredPlaces.length ? fileteredPlaces : places}
            setChildClicked={setChildClicked}
            // weatherData={weatherData}
          />
        </Grid>

      </Grid>
    </>
  );
}

export default App;
